import axios from "axios";
import { fpoCommoditiesUrl, fpoCommodityDetailUrl, fpoCommodityDropdownUrl } from "../constants/apis";
import { getAuthToken } from "../helpers/local_storage_helpers";

const authHeaders = () => ({
    headers: { Authorization: `Token ${getAuthToken()}` },
});

/**
 * GET /fpo/commodities/?page=&page_size=&search=&… — list commodities configured for the caller's FPO
 */
export const getFPOCommodities = async (params = {}) => {
    const response = await axios.get(fpoCommoditiesUrl, { ...authHeaders(), params });
    return response;
};

/**
 * GET /fpo/commodities/dropdown/ — list all global commodities available to pick from
 */
export const getFPOCommodityDropdown = async () => {
    const response = await axios.get(fpoCommodityDropdownUrl, authHeaders());
    return response;
};

/**
 * POST /fpo/commodities/ — add a commodity to the FPO (fpo_admin only)
 */
export const addFPOCommodity = async (data) => {
    const response = await axios.post(fpoCommoditiesUrl, data, authHeaders());
    return response;
};

/**
 * PATCH /fpo/commodities/<id>/ — edit a commodity's config (fpo_admin only)
 */
export const updateFPOCommodity = async (id, data) => {
    const response = await axios.patch(fpoCommodityDetailUrl(id), data, authHeaders());
    return response;
};

/**
 * DELETE /fpo/commodities/<id>/ — remove a commodity from the FPO (fpo_admin only)
 */
export const deleteFPOCommodity = async (id) => {
    const response = await axios.delete(fpoCommodityDetailUrl(id), authHeaders());
    return response;
};
